import { render, staticRenderFns } from "./Lgx196029060764139520.vue?vue&type=template&id=c9c27cf8&scoped=true&"
import script from "./Lgx196029060764139520.vue?vue&type=script&lang=js&"
export * from "./Lgx196029060764139520.vue?vue&type=script&lang=js&"
import style0 from "./Lgx196029060764139520.vue?vue&type=style&index=0&id=c9c27cf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c27cf8",
  null
  
)

export default component.exports